import { SharedHeader, SharedFooter, NAVY, ORANGE } from "./SharedLayout";

export default function PageLoader() {
  return (
    <div style={{ fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif", margin: 0, padding: 0 }}>
      <SharedHeader />
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
          background: "#f5f7fb",
        }}
      >
        {/* Spinner */}
        <div
          style={{
            width: 48,
            height: 48,
            border: `4px solid #e5ecf9`,
            borderTop: `4px solid ${NAVY}`,
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <div
          style={{
            color: NAVY,
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 0.5,
            opacity: 0.7,
          }}
        >
          Loading...
        </div>
        <style>{`
          @keyframes spin {
            0%   { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
      <SharedFooter />
    </div>
  );
}
